export const CRITERIA_TITLES_STUDENT = [
  "COURSES.COURSE.RANGE_ASSESSMENT_STUDENT",
  "COURSES.COURSE.MANDATORY_EXERCISES_STUDENT",
];

export const CRITERIA_TITLES_TEACHER = [
  "COURSES.COURSE.RANGE_ASSESSMENT",
  "COURSES.COURSE.MANDATORY_EXERCISES",
];
